module.exports = __webpack_public_path__ + "img/21.798350c8.jpg";